/**
 * VerticalFree チャットボットハンドラー
 * クリック処理と音声再生機能を統合管理
 * 作成日: 2025年9月18日
 */

(function() {
  'use strict';

  class ChatbotHandler {
    constructor() {
      this.isAnimating = false;
      this.lastClickTime = 0;
      this.audioUrl = null;
      this.preloadedAudio = null;
      this.init();
    }

    init() {
      // DOMContentLoadedまで待機
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      const chatbotContainer = document.getElementById('vf-chatbot-container');
      const chatWindow = document.getElementById('custom-chat-window');
      const closeButton = chatWindow ? chatWindow.querySelector('.chat-close-btn') : null;

      if (!chatbotContainer || !chatWindow || !closeButton) {
        // チャットボットがないページでは正常にスキップ（エラーではない）
        return;
      }

      if (window.__chatbotClickHandlerSet) return;
      window.__chatbotClickHandlerSet = true;

      this.preloadAudio();
      this.setupContainerStyles(chatbotContainer);
      this.attachEventListeners(chatbotContainer, closeButton);
    }

    preloadAudio() {
      // Shopifyアセットから音声URLを取得（theme.liquidで設定）
      this.audioUrl = window.CHATBOT_CLICK_SOUND_URL;
      console.log('[ChatbotHandler] Audio URL:', this.audioUrl);
      if (!this.audioUrl) {
        console.warn('[ChatbotHandler] No audio URL found, will use generated sound');
        return;
      }

      this.preloadedAudio = new Audio(this.audioUrl);
      this.preloadedAudio.volume = 0.4;
      this.preloadedAudio.preload = 'auto';
      console.log('[ChatbotHandler] Audio preloaded successfully');
    }

    setupContainerStyles(container) {
      container.style.position = 'fixed';
      container.style.cursor = 'pointer';
      container.style.zIndex = '999999';
      container.style.pointerEvents = 'auto';
    }

    attachEventListeners(container, closeButton) {
      // クリックイベント
      container.addEventListener('click', (e) => this.handleClick(e), true);

      // タッチデバイス対応
      container.addEventListener('touchstart', (e) => {
        e.preventDefault();
        this.handleClick(e);
      }, { passive: false });

      // 閉じるボタンのイベント
      closeButton.addEventListener('click', () => this.closeWindow());

      // iframe内のクリックを無効化
      const iframe = container.querySelector('iframe');
      if (iframe) {
        iframe.style.pointerEvents = 'none';
      }
    }

    handleClick(e) {
      // イベントの完全停止
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }

      // アニメーション中は無視
      if (this.isAnimating) {
        console.log('Animation in progress, ignoring click');
        return false;
      }

      // ダブルクリック防止（300ms以内のクリックは無視）
      const now = Date.now();
      if (now - this.lastClickTime < 300) {
        console.log('Double click prevented');
        return false;
      }
      this.lastClickTime = now;

      console.log('Chatbot icon clicked at', new Date().toISOString());

      // クリック音を再生
      this.playClickSound();

      // アニメーション開始
      this.startAnimation();

      return false;
    }

    playClickSound() {
      console.log('[ChatbotHandler] playClickSound called, preloadedAudio:', !!this.preloadedAudio);
      if (!this.preloadedAudio) {
        console.log('[ChatbotHandler] No preloaded audio, using generated sound');
        this.playGeneratedSound();
        return;
      }

      try {
        const audio = this.preloadedAudio.cloneNode();
        audio.volume = 0.4;
        audio.currentTime = 0;
        console.log('[ChatbotHandler] Playing audio file');
        audio.play().catch(err => {
          console.warn('[ChatbotHandler] Audio playback failed:', err);
          this.playGeneratedSound();
        });
      } catch (error) {
        console.warn('[ChatbotHandler] Audio playback not supported:', error);
        this.playGeneratedSound();
      }
    }

    playGeneratedSound() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();

        // シンプルなビープ音生成（簡素化版）
        const createBeep = (frequency, startTime, duration = 0.12) => {
          const oscillator = audioContext.createOscillator();
          const gain = audioContext.createGain();

          oscillator.connect(gain);
          gain.connect(audioContext.destination);

          oscillator.frequency.setValueAtTime(frequency, startTime);
          oscillator.type = 'sine';

          // エンベロープ
          gain.gain.setValueAtTime(0, startTime);
          gain.gain.linearRampToValueAtTime(0.25, startTime + 0.01);
          gain.gain.linearRampToValueAtTime(0.2, startTime + 0.08);
          gain.gain.exponentialRampToValueAtTime(0.01, startTime + duration);

          oscillator.start(startTime);
          oscillator.stop(startTime + duration);
        };

        // 2つのビープ音を生成
        createBeep(1046.5, audioContext.currentTime); // C6
        createBeep(1318.5, audioContext.currentTime + 0.15); // E6

      } catch (error) {
        console.log('Generated sound playback failed:', error);
      }
    }

    startAnimation() {
      const chatbotContainer = document.getElementById('vf-chatbot-container');
      if (!chatbotContainer) return;

      this.isAnimating = true;

      // アニメーション中は全クリックを無効化
      document.body.style.pointerEvents = 'none';
      chatbotContainer.style.pointerEvents = 'none';

      // 回転フェードアウトアニメーション
      chatbotContainer.style.transition = 'transform 2.5s cubic-bezier(0.25, 0.1, 0.25, 1), opacity 3s ease-out';
      chatbotContainer.style.transform = 'scale(0) rotate(540deg)';
      chatbotContainer.style.opacity = '0';

      // チャットウィンドウを開く
      setTimeout(() => {
        this.openWindow();
      }, 2000);
    }

    openChatWindow() {
      let attemptCount = 0;
      const tryOpenChat = () => {
        if (window.openCustomChat) {
          window.openCustomChat();
          // モーダルが表示されたら復元
          setTimeout(() => {
            this.isAnimating = false;
            document.body.style.pointerEvents = '';
          }, 500);
        } else if (attemptCount < 10) {
          attemptCount++;
          setTimeout(tryOpenChat, 100);
        } else {
          // フォールバック
          const chatWindow = document.getElementById('custom-chat-window');
          if (chatWindow) {
            chatWindow.classList.remove('custom-chat-hidden');
          }
          this.isAnimating = false;
          document.body.style.pointerEvents = '';
        }
      };
      tryOpenChat();
    }

    openWindow() {
      const chatWindow = document.getElementById('custom-chat-window');
      const chatbotContainer = document.getElementById('vf-chatbot-container');

      if (chatWindow) {
        chatWindow.classList.remove('custom-chat-hidden');
        chatWindow.classList.add('custom-chat-opening');
        requestAnimationFrame(() => {
          chatWindow.classList.remove('custom-chat-opening');
          chatWindow.classList.add('custom-chat-open');
        });
        if (chatbotContainer) {
          chatbotContainer.style.opacity = '0';
          chatbotContainer.style.pointerEvents = 'none';
        }
      }
      this.isAnimating = false;
      document.body.style.pointerEvents = '';
    }

    closeWindow() {
      const chatWindow = document.getElementById('custom-chat-window');
      const chatbotContainer = document.getElementById('vf-chatbot-container');

      if (chatWindow) {
        chatWindow.classList.add('custom-chat-hidden');
        chatWindow.classList.remove('custom-chat-open', 'custom-chat-opening');
        if (chatbotContainer) {
          chatbotContainer.style.display = '';
          chatbotContainer.style.transition = 'transform 1.2s cubic-bezier(0.25, 0.1, 0.25, 1), opacity 1.2s ease-out';
          chatbotContainer.style.transform = 'scale(1) rotate(0deg)';
          chatbotContainer.style.opacity = '1';
          chatbotContainer.style.pointerEvents = 'auto';
        }
      }
    }
  }

  // グローバルインスタンス作成
  window.VerticalFreeChatbot = new ChatbotHandler();
})();